import { useEffect, useState } from "react";
import { api, fileUrl } from "../lib/api";
import { PageHeader } from "../components/Bits";
import { Phone, User } from "lucide-react";

export default function ExecutiveBody() {
  const [list, setList] = useState([]);
  useEffect(() => { api.get("/executives").then((r) => setList(r.data)); }, []);

  return (
    <div data-testid="executive-page">
      <PageHeader title="Executive Body" subtitle="The elected office bearers of the Association, dedicated to the service of the Bar." />
      <section className="max-w-7xl mx-auto px-4 py-16">
        <div className="mb-10 text-center">
          <span className="inline-block bg-[#0B2E63] text-[#D4AF37] font-display text-lg sm:text-xl px-6 py-2 rounded-full border border-[#D4AF37]/40 tracking-wide" data-testid="executive-tenure">Executive Committee · Tenure 2024–2026</span>
        </div>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {list.map((e) => (
            <div key={e.id} className="card-elite rounded-lg overflow-hidden text-center fade-up" data-testid={`executive-${e.id}`}>
              <div className="h-2 gold-line" />
              <div className="p-8">
                <div className="w-28 h-28 mx-auto rounded-full border-2 border-[#E6C687] overflow-hidden bg-[#EAF1FB] flex items-center justify-center">
                  {e.photo ? <img src={fileUrl(e.photo)} alt={e.name} className="w-full h-full object-cover" /> : <User size={44} className="text-[#8A6320]" />}
                </div>
                <div className="mt-4 inline-block text-[11px] font-semibold tracking-widest uppercase bg-[#EAF1FB] text-[#123B7A] border border-[#E6C687] rounded-full px-3 py-1">{e.post}</div>
                <h3 className="font-display text-xl font-semibold text-[#0B2E63] mt-3">{e.name}</h3>
                {e.session_year && <div className="text-xs text-[#5A6270] mt-1">Session {e.session_year}</div>}
                {e.phone && (
                  <a href={`tel:${e.phone.replace(/\s/g, "")}`} className="mt-4 inline-flex items-center gap-2 text-sm font-semibold text-[#123B7A] hover:text-[#1E4FA0]" data-testid={`executive-call-${e.id}`}>
                    <Phone size={15} /> {e.phone}
                  </a>
                )}
              </div>
            </div>
          ))}
        </div>
        {list.length === 0 && <p className="text-center text-[#5A6270]">Executive body details will be updated shortly.</p>}
      </section>
    </div>
  );
}
